import React from 'react';
import PropTypes from 'prop-types';
import { getAnswerClass } from './utils';
import { transformPrompt } from '../../../utils';
import Image from '../../Image';

export default function MatrixHorizontal({
  question,
  rows,
  columns,
  onHandleMatrixQuestionTap,
  onHandleMatrixAnswerTap,
}) {
  return (
    <div className="matrix-wrapper">
      {rows.map((row, index) => {
        const rowColumns = columns[index];
        const isLastRow = index === rows.length - 1;

        return (
          <div
            className="matrix-horizontal answerMatrix"
            data-answer-id={row.id}
            key={row.id}
          >
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <div
              className="matrix-horizontal__question inline-children"
              data-testid="matrix-row"
              onClick={onHandleMatrixQuestionTap}
              role="button"
              tabIndex={0}
            >
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: transformPrompt(row.body) || '&nbsp;',
                }}
              />
              <div className="matrix__labels matrix-horizontal__labels">
                {rowColumns.map((column) => (
                  <span
                    key={`label-${column.id}`}
                    className="matrix__selected-answer matrix-horizontal__selected-answer"
                    data-scorepoint-id={column.id}
                    data-answer-id={row.id}
                  >
                    <span
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: transformPrompt(column.body) || '&nbsp;',
                      }}
                    />
                  </span>
                ))}
              </div>
            </div>
            <div
              className="matrix__answers matrix-horizontal__content"
              data-answer-id={row.id}
            >
              <Image
                row={{
                  imageUrl: row.image_url,
                  optimizedImageUrl: row.optimized_image_url,
                  label: row.body,
                }}
              />
              <div className="matrix-horizontal__row" data-answer-id={row.id}>
                <div className="matrix-horizontal__inner-table">
                  <div
                    className="matrix-horizontal__answers"
                    data-answer-id={row.id}
                  >
                    {rowColumns.map((column) => (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                      <div
                        key={column.id}
                        data-answer-id={row.id}
                        data-scorepoint-id={column.id}
                        className={`matrix__answer matrix-horizontal__answer ${getAnswerClass(
                          { question, column },
                        )}`}
                        onClick={onHandleMatrixAnswerTap}
                        role="button"
                        tabIndex={0}
                      >
                        <span
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: transformPrompt(column.body) || '&nbsp;',
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {!isLastRow && <div className="divider margin-md" />}
          </div>
        );
      })}
    </div>
  );
}

MatrixHorizontal.propTypes = {
  question: PropTypes.object,
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onHandleMatrixQuestionTap: PropTypes.func.isRequired,
  onHandleMatrixAnswerTap: PropTypes.func.isRequired,
};
